
function BackReference() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
			errors: '<?fieldErrors'
		},
		controller: function($parse, $scope, FormService, $q, Classes) {
			var self = this;
			
			if (!this.object[this.field.name]) {
				this.object[this.field.name] = [];
			}
			this.items = this.object[this.field.name];

			this.subfields = [];
			for (var i in this.field.fields) {
				if (this.field.fields[i].name != this.field.join.backref) {
					this.subfields.push(this.field.fields[i])
				}
			}

			this.isSubfieldVisible = function(field, object) {
				var visible_test = $parse(field.visible);
				var visible = visible_test(object);
				return visible;
			}

			$scope.$watch(function(){return self.object[self.field.name]}, function(items){
				self.items = items;
				if (self.field.join.foreignClass) {   
					for (var i in items) {
						if (items[i].hasOwnProperty(self.field.join.backref)) continue;
						Object.defineProperty(items[i], self.field.join.backref, {
							enumerable: false,
							configurable: true,
							writable: false,
							value: self.object
						});
					}
				}
			});

			this.update_sequence = function() {
				if (self.field.client && self.field.client.sort_field) {
					for (var i=0; i<self.items.length; i++) {
						self.items[i][self.field.client.sort_field] = i + 1;
					}
				}
			}

			this.append_new = function(data) {
				return FormService.fetchDefaultInstance(self.field.fields).then(function(instance){
					if (typeof data == "object") angular.extend(instance, data)
					if (self.field.join.foreignClass) {   
						instance = Classes[self.field.join.foreignClass].create(instance)
						//instance[self.field.join.backref] = self.object;  // causes circural refences when saving
						Object.defineProperty(instance, self.field.join.backref, {
							enumerable: false,
							configurable: true,
							writable: false,
							value: self.object
						});
					}
					self.items.push(instance);
					self.update_sequence();
					self.errors = null;
					return instance;
				});
			}

			this.remove = function(obj) {
				for (var i in self.items) {
					if (self.items[i] === obj) {
						self.items.splice(i, 1);
						break;
					}
				}
				self.update_sequence();
			}

			this.editModal = function(obj, groups, layout) {
				groups = groups || 'edit';
				layout = layout || ['edit'];
				if (typeof groups == "string") groups = [groups];
				var formfields = [];
				for (f in self.field.fields) {
					var field = self.field.fields[f];
					var fgroups = (typeof field.groups == "string"? [field.groups] : field.groups);
					var match = false;
					for (g in groups) {
						for (fg in fgroups) {
							if (groups[g] == fgroups[fg]) match = true;
						}
					}
					if (match) {
						formfields.push(field);
					}
				}
				var form = {
					'title': 'Edit image',
					'prompt': '',
					'btn': 'Save',
					'templateUrl': null,  // form-service default
					'params': formfields,
					'layout': layout,
					'submit': function(data) {
						for (f in formfields) {
							var field = formfields[f];
							obj[field.name] = data[field.name];
						}
						return $q.resolve(data);
					},
					'modalOptions': {} // $modal options
				}
				return FormService.activateFormModal(form, angular.copy(obj));
			}




		},
		controllerAs: '$ref'
	}
}


var BackReferenceFieldCtrl = function($scope, FormNewInstanceFactory, Classes, $state) {

	var self = this;
	this.createMode = !$scope.oCtrl.createMode;
	this.Class = Classes[$scope.field.join.foreignClass];
	if (!$scope.object[$scope.field.name]) {
		$scope.object[$scope.field.name] = [];
	}
	self.items = $scope.object[$scope.field.name];
	$scope.$watch('object[field.name]', function(items) {
		self.items = items;
	});
	
	this.append_new = function(data) {
		var classname = $scope.field.join.foreignClass;
		return FormNewInstanceFactory.fetchNewInstance(classname).then(function(obj){
			if (typeof data == "object") obj.fill(data);
			obj[$scope.field.join.backref] = $scope.object;
			self.items.push(obj);
			return obj;
		});
	}
	
	this.remove = function(obj) {
		for (var i in self.items) {
			if (self.items[i] === obj) {
				self.items.splice(i, 1);
				break;
			}
		}
	}

	this.gotoObject = function(oClass, vid, event/*=null*/) {
		if(event && (event.ctrlKey || event.metaKey)){
			var url = $state.href('module.detail', {page:oClass, vid: vid});
			window.open(url,'_blank');
		}else{
			$state.go('module.detail', {page:oClass, vid: vid});
		}
	}
	
	window.brefCtrl = this;

}


var FileBackreferenceFieldCtrl = function(ReferenceCtrl, $q) {

	var slice = Array.prototype.slice;
	
	var self = this;
	this.message = null;
	this.busy = false;

	this.readFile = function (file) {
        var deferred = $q.defer();

		var reader = new FileReader()
        reader.onload = function(e){
            deferred.resolve({
    			mime: file.type,
				filename: file.name,
				data: e.target.result,
				title: file.name.replace(/\.[a-z0-9]+$/, '').replace(/[_\\-]/g, ' ')
	    	});
        }
        reader.onerror = function(e) {
            deferred.reject(e);
        }
        reader.readAsDataURL(file);

        return deferred.promise;
    }
    
    this.uploadFiles = function(files) {
    	self.is_busy = true;
        return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
    		for (var i in values) {
    			ReferenceCtrl.append_new(values[i]);
    		}
			self.is_busy = false;
    	}).catch(function(e){
    		self.message={type:'danger', body:e}
			self.is_busy = false;
    	});
    }
}


var CroppieBackreferenceFieldCtrl = function(ReferenceCtrl, $q, $uibModal) {

	var slice = Array.prototype.slice;
	
	var self = this;
	this.message = null;
	this.is_busy = false;
	
	self.openModal = function(item, ReferenceCtrl){
		$uibModal.open({
			animation: true,
			//ariaLabelledBy: 'modal-title',
			//ariaDescribedBy: 'modal-body',
			templateUrl: 'framework/partials/forms/field-widget-backreferencefield-images-croppie-modal.html',
			controller: function ($uibModalInstance, ApiRootUrl, item, ReferenceCtrl) {
				var modal = this;

				modal.croppie_instance = null;
				modal.croppie_image = null;				
				modal.croppie_options = {
					viewport: { width: 200, height: 200, type: 'circle' },
					boundary: { width: 300, height: 300 },
				}	

				modal.croppie_init = function(){

					modal.croppie_image = item;	
					if(ReferenceCtrl.field.client && ReferenceCtrl.field.client.croppie_options){
						modal.croppie_options = ReferenceCtrl.field.client.croppie_options;
					}
					modal.croppie_instance = $('#croppie-container').croppie(modal.croppie_options);
					modal.croppie_instance.croppie('bind', {
						url: item.data
					});
					
				}
				setTimeout(function(){ modal.croppie_init(); }, 400);

				modal.croppie_result = function(){
					modal.croppie_instance.croppie('result', {type:'base64', size:'original', format:'jpeg', circle:false}).then(function(resp) {			
						if(modal.croppie_image){
							modal.croppie_image.data = resp;
							
							if(ReferenceCtrl.field.client && ReferenceCtrl.field.client.only_single_image)
								ReferenceCtrl.items.length = 0
							
							ReferenceCtrl.append_new(modal.croppie_image);
						}
						modal.croppie_cancel();
					});
				}				

				modal.croppie_cancel = function () {
					modal.croppie_instance.croppie('destroy');
					modal.croppie_instance = null;
					modal.croppie_image = null;
					$uibModalInstance.dismiss('cancel');
				};
			},
			controllerAs: '$modal',
			size: 'lg',
			appendTo: undefined,
			resolve: {
				item: function () {
					return item;
				},
				ReferenceCtrl: function() {
					return ReferenceCtrl;
				}
			}
		});				
		
	}

	this.readFile = function (file) {
        var deferred = $q.defer();

		var reader = new FileReader()
        reader.onload = function(e){
            deferred.resolve({
    			mime: file.type,
				filename: file.name,
				data: e.target.result,
				title: file.name.replace(/\.[a-z0-9]+$/, '').replace(/[_\\-]/g, ' ')
	    	});
        }
        reader.onerror = function(e) {
            deferred.reject(e);
        }
        reader.readAsDataURL(file);

        return deferred.promise;
    }
    
    this.uploadFiles = function(files) {
    	self.is_busy = true;
        return $q.all(slice.call(files, 0).map(self.readFile)).then(function(values){
    		for (var i in values) {
    			//ReferenceCtrl.append_new(values[i]);
				//self.croppie_init(values[i]);
				self.openModal(values[i], ReferenceCtrl);
    		}
			self.is_busy = false;
    	}).catch(function(e){
    		self.message={type:'danger', body:e}
			self.is_busy = false;
    	});
    }
}


angular.module('forms.fields.backreference', [])
.controller('BackReferenceFieldCtrl', BackReferenceFieldCtrl)
.controller('FileBackreferenceFieldCtrl', FileBackreferenceFieldCtrl)
.controller('CroppieBackreferenceFieldCtrl', CroppieBackreferenceFieldCtrl)
.directive('backReference', BackReference)



.directive('fullscreenGallery', function() {
	return {
		bindToController: {
			fullscreenGallery: '=',
		},
		controller: function($scope, $rootScope, $element, $attrs, $uibModal, $q) {
	    	var self = this;
	    	this.focus = null;
	    	this.gallery = this.fullscreenGallery;
	    	
	    	var parent = $element.parent();
	    	this.is_fullscreen = false;
	    	this.openFullscreen = function() {
	    		if (self.is_fullscreen) return;
	    		console.log('openFullscreen');
	    		window.scrollTo(0,0);
	    		$element.appendTo('body').addClass('fullscreen');
	    		$('body').css({'overflow-y':'hidden'});
	    		self.is_fullscreen = true;
	    	}
	    	
	    	this.closeFullscreen = function() {
	    		if (!self.is_fullscreen) return;
	    		$element.appendTo(parent).removeClass('fullscreen');
	    		$('body').css({'overflow-y':'auto'});
	    		self.is_fullscreen = false;
	    	}
	    	
	    	this.setFocus = function(file) {
				var url = file.data || file.download[0].href;
				self.focus = file;
				if (!self.focus.src) {
					var img = new Image;
					self.focus.src = file.data || null;
					img.onload = function() {
						$rootScope.$apply(function(){
							self.focus.src = url;
						});
					}
					img.src = url;
				}
			}
			
			this.fastFocus = function(file) {
				self.focus = file;
			}
			
			this.next = function(offset) {
				var curr = this.gallery.indexOf(self.focus);
				var next = curr+offset;
				if (next < 0) next = this.gallery.length - 1;
				if (next >= this.gallery.length) next = 0;
				self.setFocus(this.gallery[next]);
			}
			
			
			this.editFile = function(file) {
				var save = function(data) {
					file.title = data.title;
					return $q.resolve(true);
				}
				//var dlg = dialogs.create('partials/grid/dialog-save-tab.html','SaveCancelDialogCtrl',{data:tab,save:save},{size:'lg'});
				var dlg = $uibModal.open({
				      animation: true,
				      templateUrl: 'partials/dialog-image-title.html',
				      controller: 'SubmitCancelDialogCtrl as dCtrl',
				      size: 'md',
				      resolve: {
				        params: function () {
				          return {data:{title:file.title},submit:save}
				        }
				      }
				});
			}
	    	
		},
		controllerAs: 'gallery'
	}
})


